import React, { useContext } from 'react';
import { formatTodaysHours, getParsedHours } from '../../utils/map';
import { LocationContext } from './locationFinder';
import { useTranslation } from 'react-i18next';

export default function LocationCard({ location, dayOfWeek }) {
  const { t, i18n } = useTranslation();
  const { handleSetActiveLocation } = useContext(LocationContext);

  return (
    <div className="tw-px-4 tw-bg-slate-100 ">
      <div className="tw-border-0 tw-grid tw-gap-4 tw-py-4 tw-border-solid tw-border-b tw-border-black">
        <div className="tw-justify-between tw-flex">
          <div className="tw-items-center tw-flex-1 tw-gap-4 tw-flex">
            {location.brand && <div className="tw-w-12"></div>}
            <div className="tw-flex-1">
              <h2 className="tw-font-bold tw-tracking-wide tw-text-lg md:tw-text-xl tw-text-blue tw-m-0">
                {location.Site_Description}
              </h2>
              <p className="tw-font-medium tw-text-base tw-m-0 tw-grid">
                <span>{location.Address_1} </span>
                <span>
                  {location.City}, {location.Province}, {location.Postal_Code}
                </span>
              </p>
            </div>
          </div>
          {!!location.distanceFromInKms && (
            <div className="tw-gap-1 tw-items-center tw-flex ">
              <div>
                <svg
                  className="tw-h-4 tw-w-4 tw-text-blue"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.99922 18.55C4.79922 14.0318 2.69922 10.5485 2.69922 8.1C2.69922 4.4273 5.51982 1.45 8.99922 1.45C12.4786 1.45 15.2992 4.4273 15.2992 8.1C15.2992 10.5485 13.1992 14.0318 8.99922 18.55ZM8.99922 16.555C12.2992 12.8421 13.9492 10.0238 13.9492 8.1C13.9492 5.21431 11.733 2.875 8.99922 2.875C6.26541 2.875 4.04922 5.21431 4.04922 8.1C4.04922 10.0238 5.69922 12.8421 8.99922 16.555ZM8.99922 10.95C7.50805 10.95 6.29922 9.67401 6.29922 8.1C6.29922 6.52599 7.50805 5.25 8.99922 5.25C10.4904 5.25 11.6992 6.52599 11.6992 8.1C11.6992 9.67401 10.4904 10.95 8.99922 10.95ZM8.99922 9.525C9.7448 9.525 10.3492 8.887 10.3492 8.1C10.3492 7.31299 9.7448 6.675 8.99922 6.675C8.25363 6.675 7.64922 7.31299 7.64922 8.1C7.64922 8.887 8.25363 9.525 8.99922 9.525Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <span className="tw-font-medium tw-text-yellow tw-text-base">
                {location.distanceFromInKms} KM
              </span>
            </div>
          )}
        </div>
        <div className="tw-items-end tw-justify-between tw-flex">
          <div>
            <div className="tw-text-base tw-font-light">
              {location.Hours_of_Operation &&
                getParsedHours(location.Hours_of_Operation)}
            </div>
            {/* <div className="tw-font-light">No of Amenities :{location.filters.length}</div> */}
          </div>
          <div>
            <button
              className="tw-py-2 tw-text-sm tw-font-medium tw-border-none tw-text-white tw-rounded-md tw-px-4 tw-bg-blue hover:tw-bg-blue-light focus:tw-bg-blue-light tw-uppercase"
              onClick={() => handleSetActiveLocation(location)}>
              {t('VIEW DETAILS')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
